import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const TeacherSubjectAssignment = lazy(() => import('../pages/assignments/TeacherSubjectAssignment'));
const ClassAssignment = lazy(() => import('../pages/assignments/ClassAssignment'));
const TutorGroupAssignment = lazy(() => import('../pages/assignments/TutorGroupAssignment'));

const AssignmentRoutes = () => {
  return (
    <Routes>
      <Route path="teacher-subjects" element={<TeacherSubjectAssignment />} />
      <Route path="class-assignments" element={<ClassAssignment />} />
      <Route path="tutor-groups" element={<TutorGroupAssignment />} />
    </Routes>
  );
};

export default AssignmentRoutes;
